import React, {useState} from "react";
import {
    FAQCell,
    FAQHeader,
    FAQMainContainer,
    Filler,
    Info,
    InfoHeader,
    InfoMainContainer,
    TopContainer
} from "./Info.styled";
import {ReactComponent as ArrowUp} from "../../assets/icons/arrow_up.svg";
import {ReactComponent as ArrowDown} from "../../assets/icons/arrow_down.svg";
import {useSelector} from "react-redux";
import {selectors} from "../../redux/selectors";
import {AppText} from "../../utils";

export const TOFInfo: React.FC = () => {
    const [state1, setState1] = useState<boolean>(false);
    const [state2, setState2] = useState<boolean>(false);
    const [state3, setState3] = useState<boolean>(false);
    const [state4, setState4] = useState<boolean>(false);
    const [state5, setState5] = useState<boolean>(false);
    const [state6, setState6] = useState<boolean>(false);
    const [state7, setState7] = useState<boolean>(false);
    const [state8, setState8] = useState<boolean>(false);
    const lang = useSelector(selectors.selectLang)
    return (
        <Info>
            <TopContainer>
                <div>{AppText[lang].info.about}</div>
                <div>
                    <p>
                        {AppText[lang].info.about_a}
                    </p>
                </div>
            </TopContainer>
            <InfoMainContainer>
                <div>FAQ</div>
                <FAQCell>
                    <FAQHeader onClick={() => setState1(!state1)}>
                        <div>{AppText[lang].info.a}</div>
                        <div>
                            {state1 ? (<ArrowUp />) : (<ArrowDown/>) }
                        </div>
                    </FAQHeader>
                    <FAQMainContainer isOpen={state1}>
                        {AppText[lang].info.a_a}
                    </FAQMainContainer>
                </FAQCell>
                <FAQCell>
                    <FAQHeader onClick={() => setState2(!state2)}>
                        <div>{AppText[lang].info.b}</div>
                        <div>
                            {state2 ? (<ArrowUp />) : (<ArrowDown/>) }
                        </div>
                    </FAQHeader>
                    <FAQMainContainer isOpen={state2}>
                        {AppText[lang].info.b_b}
                    </FAQMainContainer>
                </FAQCell>
                <FAQCell>
                    <FAQHeader onClick={() => setState3(!state3)}>
                        <div>{AppText[lang].info.c}</div>
                        <div>
                            {state3 ? (<ArrowUp />) : (<ArrowDown/>) }
                        </div>
                    </FAQHeader>
                    <FAQMainContainer isOpen={state3}>
                        {AppText[lang].info.c_c}
                    </FAQMainContainer>
                </FAQCell>
                <FAQCell>
                    <FAQHeader onClick={() => setState4(!state4)}>
                        <div>{AppText[lang].info.d}</div>
                        <div>
                            {state4 ? (<ArrowUp />) : (<ArrowDown/>) }
                        </div>
                    </FAQHeader>
                    <FAQMainContainer isOpen={state4}>
                        {AppText[lang].info.d_d}
                    </FAQMainContainer>
                </FAQCell>
                <FAQCell>
                    <FAQHeader onClick={() => setState5(!state5)}>
                        <div>{AppText[lang].info.e}</div>
                        <div>
                            {state5 ? (<ArrowUp />) : (<ArrowDown/>) }
                        </div>
                    </FAQHeader>
                    <FAQMainContainer isOpen={state5}>
                        {AppText[lang].info.e_e}
                    </FAQMainContainer>
                </FAQCell>
                <FAQCell>
                    <FAQHeader onClick={() => setState6(!state6)}>
                        <div>{AppText[lang].info.f}</div>
                        <div>
                            {state6 ? (<ArrowUp />) : (<ArrowDown/>) }
                        </div>
                    </FAQHeader>
                    <FAQMainContainer isOpen={state6}>
                        {AppText[lang].info.f_f}
                    </FAQMainContainer>
                </FAQCell>
                <FAQCell>
                    <FAQHeader onClick={() => setState7(!state7)}>
                        <div>{AppText[lang].info.g}</div>
                        <div>
                            {state7 ? (<ArrowUp />) : (<ArrowDown/>) }
                        </div>
                    </FAQHeader>
                    <FAQMainContainer isOpen={state7}>
                        {AppText[lang].info.g_g}
                    </FAQMainContainer>
                </FAQCell>
                <FAQCell>
                    <FAQHeader onClick={() => setState8(!state8)}>
                        <div>{AppText[lang].info.h}</div>
                        <div>
                            {state8 ? (<ArrowUp />) : (<ArrowDown/>) }
                        </div>
                    </FAQHeader>
                    <FAQMainContainer isOpen={state8}>
                        {AppText[lang].info.h_h}
                    </FAQMainContainer>
                </FAQCell>
                <Filler/>
            </InfoMainContainer>
        </Info>
    )
}